import React from 'react';
import { useTranslation } from 'react-i18next';
import AppLogo from './AppLogo';

/**
 * The phone's top bar: the mark.
 *
 * It used to hold a second way into the menu, beside the tab bar's own Menu
 * tab; two triggers for one sheet, at opposite corners. The tab is the one
 * left, and the sheet now rises from it.
 *
 * Not sticky: with nothing to tap it has no reason to stay, and pinned it sat
 * under the (also sticky) demo banner.
 *
 * Annotation pass 3 dropped the theme switch that used to sit at the right end.
 * It is one tap further inside the menu, next to language, which is where the
 * desktop sidebar keeps it too — and a top bar with a single destination reads
 * as chrome rather than as a place with its own controls.
 *
 * Pass 4 gave the right end to demo mode, holding the "create free account"
 * button while App dropped the demo banner below 900px. D2 reversed that: the
 * banner is back at every width because it now warns that demo edits are not
 * saved, and it brings its own button — so keeping one here would put two
 * identical CTAs one above the other.
 */
const MobileTopBar = () => {
    const { t } = useTranslation();

    return (
        <header className="mobile-top">
            <AppLogo className="sm" />
            <span className="logo-name">{t('auth.appName')}</span>
        </header>
    );
};

export default MobileTopBar;
